@let steps = path | async;
@if (steps && steps.length && steps[0] && steps[0].label !== "home") {
  <div class="wrapper">
    <app-button variant="basic" (click)="goBack()">
      <app-icon icon="keyboard_backspace" />
    </app-button>
    <app-link i18n variant="basic" routerLink="/"> HOME </app-link>
    @for (step of steps; track step.label; let idx = $index) {
      /
      @if (idx === steps.length - 1) {
        <span>{{ step.label }}</span>
      } @else {
        <app-link variant="basic" [routerLink]="step.url">
          <span>{{ step.label }}</span>
        </app-link>
      }
    }
  </div>
}
